<ng-container *ngIf="lowLevelTitle$|async as vm">
  <ng-container *ngIf="!vm.title">
    <div class="row">
      <div class="col-12">
        <h5 class="my-3 text-mad text-uppercase">Land Area</h5>
        <hr class="active" />
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.title">
    <div class="row">
      <div class="col-12">
        <h5 class="my-3 text-black text-uppercase">
          {{vm.title}}
        </h5>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container [formGroup]="form">
  <div class=row *ngIf="!isBuilding">
    <div class="col-4">
      <mat-form-field class="mat-form-field">
        <input matInput [placeholder]="'Plot area' + (unitOfAreaMeasurement$|async)" formControlName="plot_area" mask="separator.2" thousandSeparator="," />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <button class="btn btn-primary" type="button" (click)="onAddItem()">
        Add Component
      </button>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <mat-table [dataSource]="dataSource$">
        <ng-container matColumnDef="index">
          <mat-header-cell *matHeaderCellDef>Land Parcel Component</mat-header-cell>
          <mat-cell *matCellDef="let item; let index = index">
            {{ index + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="unit_area_measurement">
          <mat-header-cell *matHeaderCellDef>Area Unit Type</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.unitAreaMeasurementName }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="surface">
          <mat-header-cell *matHeaderCellDef>Surface</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.surface | mask:'separator':{thousandSeparator:','} }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="limited_use">
          <mat-header-cell *matHeaderCellDef>Restricted / limited use</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.limitedUse ? item.limitedUse : 'N/A' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="3d_restriction">
          <mat-header-cell *matHeaderCellDef>3D restriction</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <div
              *ngIf="(item.undergroundRestriction > 0 || item.aerialRestriction > 0) && item.unitLengthMeasurementAcronym; else na">
                {{
                  item.undergroundRestriction > 0
                    ? 'Depth: ' + (item.undergroundRestriction | mask:'separator':{thousandSeparator: ','} ) + item.unitLengthMeasurementAcronym
                    : ''
                }}
                {{item.undergroundRestriction > 0 && item.aerialRestriction > 0 ? ', ' : ''}}
                {{
                  item.aerialRestriction > 0
                  ? 'Height: ' + (item.aerialRestriction | mask:'separator':{thousandSeparator: ','} ) + item.unitLengthMeasurementAcronym
                  : ''
                }}
            </div>
            <ng-template #na>
              N/A
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let item; let index = index">
            <button mat-icon-button type="button" color="primary" (click)="onEditItem({item, index})">
              <mat-icon>create</mat-icon>
            </button>

            <button mat-icon-button type="button" color="warn" (click)="onDeleteItem(index)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="['index', 'unit_area_measurement', 'surface', 'limited_use', '3d_restriction', 'actions']"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: ['index', 'unit_area_measurement', 'surface', 'limited_use', '3d_restriction', 'actions']"></mat-row>
      </mat-table>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-4">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select placeholder="Planning Status of the land parcel" formControlName="planning_status_id">
          <mat-option *ngFor="let planingStatus of planningStatuses$|async"
            [value]="planingStatus.id">{{planingStatus.name}}</mat-option>
        </mat-select>
        <mat-error>
          Planning Status of the land parcel
          <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-4">
      <mat-form-field class="mat-form-field-fluid">
        <mat-select placeholder="Quality of soil and degradation" formControlName="qos_degradation_id">
          <mat-option *ngFor="let qosDegradation of qosDegradations$|async"
            [value]="qosDegradation.id">{{qosDegradation.name}}</mat-option>
        </mat-select>
        <mat-error>
          Quality of soil and degradation
          <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-lg-4">
      <mat-form-field class="mat-form-field-fluid">
        <input matInput placeholder="Environmental considerations" formControlName="env_considerations" />
        <mat-icon matSuffix class="cursor-pointer" (click)="$event.stopPropagation();" container="body"
          [ngbPopover]="'TOOLTIP.LAND_PARCEL.ENV_CONSIDERATION.DESCRIPTION' | translate">help
        </mat-icon>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 kt-margin-bottom-10-mobile mt-4">
      <mat-form-field class="mat-form-field-fluid">
        <input matInput placeholder="Other considerations" formControlName="other_considerations" />
      </mat-form-field>
    </div>
  </div>
</ng-container>